var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-combobox", {
    ref: "comboBox",
    staticClass: "mt-2",
    attrs: {
      clearable: _vm.clearable,
      multiple: _vm.multiple,
      "open-on-clear": "",
      loading: _vm.isSearching,
      "search-input": _vm.search,
      "persistent-hint": _vm.persistentHint,
      hint: _vm.hint,
      "no-filter": "",
      label: _vm.label,
      rules: _vm.rules,
      solo: _vm.solo,
      items: _vm.filteredItems,
      "item-text": "primaryName",
      "item-value": "primaryName",
      "return-object": "",
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event
      },
      "update:search-input": function ($event) {
        _vm.search = $event
      },
    },
    scopedSlots: _vm._u(
      [
        !_vm.defaultItemSelection
          ? {
              key: "item",
              fn: function ({ item, index }) {
                return [
                  _vm._t(
                    "item",
                    function () {
                      return [
                        _c(
                          "v-list-tile-content",
                          [
                            _c(
                              "v-list-tile-title",
                              {
                                class: {
                                  "info--text":
                                    _vm.value && item.id == _vm.value.id,
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(item.primaryName) +
                                    "\n        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-sub-title",
                              [
                                item.allNames.length
                                  ? _c("span", [_vm._v("Data types: ")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  item.dataTypes,
                                  function (dataType, subIindex) {
                                    return _c(
                                      "v-chip",
                                      { key: subIindex, attrs: { small: "" } },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(dataType.type) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    { item: item, index: index }
                  ),
                ]
              },
            }
          : null,
      ],
      null,
      true
    ),
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v
      },
      expression: "selectedItem",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }